// extracted by mini-css-extract-plugin
export default {"userIntegrations":"UserIntegrations_userIntegrations__S23pY"};